import { Component } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { PresetService } from "../../../../../shared/services/preset.service";
import { UserService } from "../../../../user/services/user.service";
import { CamerallaAuthService } from "../../../../../shared/services/authentication-services/cameralla-auth.service";
import { LanguageConstant } from "../../../../../shared/constants/language-constant";
import { GroupService } from "../../../../user/services/group.service";

@Component({
    selector: 'app-battle-list',
    templateUrl: './battle-list.html',
})
export class BattleListComponent {
    constructor(protected presetService: PresetService,
                protected toastr: ToastrService,
                protected route: ActivatedRoute,
                protected userService: UserService,
                protected groupService: GroupService,
                protected camerallaAuthService: CamerallaAuthService,
                protected router : Router) {
        this.localUserId = +this.camerallaAuthService.getLocalUserInfo()['id'];
    
    }
    
    battleList = [];
    localUserId;
    
    ngOnInit() {
        this.userService.getPersonalDetails(this.localUserId).then((user: any) => {
            this.groupService.getMyGroups(this.localUserId, 'joined').subscribe((groups: any) => {
                let groupIds = [];
                if (groups && groups.Data && groups.Data.length) {
                    const filtered = groups.Data.filter((item) => {
                        return item.group.metaData && item.group.metaData.battleFeature;
                    });
                    
                    groupIds = filtered.map(group => +group.groupId);
                }
                
                this.presetService.getAvailableBattle(groupIds).subscribe((res: any) => {
                    this.battleList = res.Data;
                    if (user.preferredLanguage === LanguageConstant.ENG) {
                        this.battleList.forEach((battle) =>{
                            if (battle.language && battle.language.en) {
                                if (battle.language.en.name) {
                                    battle.name = battle.language.en.name;
                                }
                                if (battle.language.en.shortDescription) {
                                    battle.shortDescription = battle.language.en.shortDescription;
                                }
                            }
                        })
                    }
                })
            })
        })
    }
    
    navigateToBattleDetails(id) {
        this.router.navigate([`/preset/battles/` + id]);
    }
    
}
